<template>
  <b-container fluid>
    <b-form @submit.prevent="submit">
      <b-row class="mb-3">
        <b-col cols="12">
          <h1 class="font-weight-bold text-primary">{{ $route.params.id ? 'Update' : 'Create' }} Extra</h1>
        </b-col>
      </b-row>
      <b-row v-if="isLoading">
        <b-col cols="12">
          <p class="text-center"><b-spinner variant="secondary"></b-spinner></p>
        </b-col>
      </b-row>
      <b-row v-if="!isLoading">
        <b-col cols="12">
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group label="Extra Name" :invalid-feedback="validationInvalidFeedback(errors.errors, 'name')">
                <b-form-input :disabled="isSaving" type="text" :state="validationState(errors.errors, 'name')" v-model="extra.name" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group label="Extra SKU" :invalid-feedback="validationInvalidFeedback(errors.errors, 'sku')">
                <b-form-input :disabled="isSaving" type="text" :state="validationState(errors.errors, 'sku')" v-model="extra.sku" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="Cost Price" :state="validationState(errors.errors, 'cost_price')" :invalid-feedback="validationInvalidFeedback(errors.errors, 'cost_price')">
                <b-input-group prepend="£">
                  <b-form-input :disabled="isSaving" :state="validationState(errors.errors, 'cost_price')" v-model="extra.cost_price" />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Price" :state="validationState(errors.errors, 'price')" :invalid-feedback="validationInvalidFeedback(errors.errors, 'price')">
                <b-input-group prepend="£">
                  <b-form-input :disabled="isSaving" :state="validationState(errors.errors, 'price')" v-model="extra.price" />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col class="d-flex flex-row" cols="12" md="4" offset-md="8">
              <b-button block class="align-self-end mb-3" type="submit" variant="secondary"><b-spinner small v-if="isSaving"></b-spinner><span v-if="!isSaving">Save</span></b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import validation from '../../mixins/validation'
import { mapActions, mapGetters } from 'vuex'

export default {
  mixins: [validation],
  created () {
    if (this.$route.params.id) {
      this.fetch(this.$route.params.id)
    }
  },
  computed: {
    ...mapGetters('extras', ['errors', 'isLoading', 'isSaving', 'single'])
  },
  data () {
    return {
      correspondenceFilter: null,
      upcomingCorrespondenceFilter: null,
      types: [
        { text: 'Simple Extra', value: 'simple' },
        { text: 'Grouped Extra', value: 'grouped' },
        { text: 'External/Affiliate Extra', value: 'external' },
        { text: 'Variable Extra', value: 'variable' }
      ],
      extra: {
        id: null,
        sku: null,
        name: null,
        cost_price: null,
        price: null,
      },
    }
  },
  methods: {
    ...mapActions('extras', ['fetch', 'save']),
    submit () {
      let data = {
        id: this.$route.params.id,
        sku: this.extra.sku,
        name: this.extra.name,
        cost_price: this.extra.cost_price,
        price: this.extra.price,
      }

      this.save(data).then(response => {
        if([ 200, 201 ].includes(response.status)) this.$router.push({
          name: 'dash.extras.list',
          params: {
            notifications: [{
              variant: 'success',
              title: `Extra #${response.data.id}`,
              subtitle: `${response.data.name} - £${response.data.price}`,
              text: `The extra has been ${this.$route.params.id ? 'updated' : 'created'} successfully.`,
              timeout: 5000
            }]
          }
        })
      })
    }
  },
  watch: {
    single (newUser) {
      this.extra = this.single
    }
  }
}
</script>

<style>

</style>
